import { showApiErrors } from '@/utils';
import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import {
  cleanSync,
  getCleanupDatabaseData,
  getEntities,
  getProductSync,
  syncByEntity,
  syncEntity,
  syncSpecificProduct,
} from './actionCreators';
import { AkeneoSyncState, SLICE_NAME, initialState } from './models';

export const akeneoSyncSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEntities.fulfilled, (state: AkeneoSyncState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.entities = Object.values(payload)
          .filter((entity) => entity !== null)
          .sort((a, b) => {
            if (a === null || b === null) return 0;
            const firstDate = new Date(a.updatedAt);
            const secondDate = new Date(b.updatedAt);
            return secondDate.getTime() - firstDate.getTime();
          });
      })
      .addCase(getProductSync.fulfilled, (state: AkeneoSyncState, action) => {
        const { payload } = action;
        state.productsSync = payload.records;
        state.isLoading = false;
      })
      .addCase(getCleanupDatabaseData.fulfilled, (state: AkeneoSyncState, action) => {
        const { payload } = action;
        state.cleanupDatabaseData = payload;
        state.isLoading = false;
      })
      .addMatcher(isFulfilled(syncEntity, syncByEntity, syncSpecificProduct, cleanSync), (state: AkeneoSyncState) => {
        state.isLoading = false;
      })
      .addMatcher(
        isPending(
          getEntities,
          getProductSync,
          getCleanupDatabaseData,
          syncEntity,
          syncByEntity,
          syncSpecificProduct,
          cleanSync,
        ),
        (state: AkeneoSyncState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(
          getEntities,
          getProductSync,
          getCleanupDatabaseData,
          syncEntity,
          syncByEntity,
          syncSpecificProduct,
          cleanSync,
        ),
        (state: AkeneoSyncState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;
          showApiErrors(error);
        },
      );
  },
});
